module.exports = __webpack_public_path__ + "88a9d45c04c9d1d8a16d4340761f1438.png";